module.exports = __webpack_public_path__ + "static/media/20231026-DSC_4954.2f168abd.jpg";